import React, { useState } from 'react';

interface LoginPageProps {
    onLogin: (token: string) => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [attempts, setAttempts] = useState(0);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ password })
            });
            const data = await res.json();
            if (res.ok) {
                onLogin(data.token);
            } else {
                setAttempts(a => a + 1);
                if (res.status === 429) {
                    setError('Trop de tentatives. Réessayez dans 15 minutes.');
                } else {
                    setError(`Mot de passe incorrect${attempts >= 2 ? ` (${5 - attempts - 1} essai(s) restant)` : ''}`);
                }
            }
        } catch {
            setError('Erreur de connexion au serveur.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)'
        }}>
            <div style={{
                background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20,
                padding: '48px 40px', width: 360, boxShadow: '0 25px 50px rgba(0,0,0,0.5)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <div style={{ fontSize: 48, marginBottom: 12 }}>📡</div>
                    <h1 style={{ color: '#fff', margin: 0, fontSize: 22, fontWeight: 700 }}>Activity Tracker</h1>
                    <p style={{ color: 'rgba(255,255,255,0.4)', margin: '8px 0 0', fontSize: 14 }}>Accès sécurisé</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder="Mot de passe"
                        autoFocus
                        style={{
                            width: '100%', padding: '14px 16px', borderRadius: 10,
                            border: error ? '1.5px solid #ef4444' : '1.5px solid rgba(255,255,255,0.15)',
                            background: 'rgba(255,255,255,0.08)', color: '#fff',
                            fontSize: 15, outline: 'none', boxSizing: 'border-box', marginBottom: 12
                        }}
                    />
                    {error && (
                        <p style={{ color: '#ef4444', fontSize: 13, margin: '0 0 12px', textAlign: 'center' }}>{error}</p>
                    )}
                    <button
                        type="submit"
                        disabled={loading || !password}
                        style={{
                            width: '100%', padding: '14px', borderRadius: 10, border: 'none',
                            background: loading ? 'rgba(99,102,241,0.5)' : 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                            color: '#fff', fontWeight: 700, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        {loading ? 'Connexion...' : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
    );
}
